import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h3, h4, paragraphMedium } from '@helpers/typography';
import CtaLinkStyles from '@stories/Components/Buttons/CtaLink/CtaLink.styles';
import { ReadMoreStyles } from '@stories/Components/Buttons/ReadMore/ReadMore.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  &[data-layout='default'] {
    ${SectionWrapperStyles.Inner} {
      max-width: calc(1020px + (var(--sitePadding) * 2));
    }
  }

  &[data-theme='dark'] {
    color: ${brand.white};
    background-color: ${brand.primary.blue};
  }

  &[data-theme='grey'] {
    background-color: ${brand.primary.blueGrey};
  }

  &[data-theme='none'] {
    color: var(--accountFgColour);
    background-color: transparent;
  }

  @media ${from(Device.TabletLarge)} {
    &[data-layout='split-text-content'] {
      ${SectionWrapperStyles.Inner} {
        ${baseGrid};
      }
    }
  }

  &[data-layout='float-left'] {
    padding: 0;

    ${SectionWrapperStyles.Inner} {
      margin: 0 auto 0 0;
      padding-left: 0;
      max-width: 900px;
    }
  }
`;
const Title = styled.h2 `
  ${h4};

  h1& {
    ${h3};
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: auto / span 12;
  }

  [data-layout='default'] & {
    ${fonts.apparat.semiBold};

    @media ${from(Device.TabletLarge)} {
      ${fonts.apparat.medium};
    }
  }

  [data-layout='split-text-content'] & {
    span {
      max-width: ${fluid(340, 720)};
    }
  }
`;
const ContentWrapper = styled.div `
  ${ReadMoreStyles.Container} {
    margin-top: 24px;
  }

  ${CtaLinkStyles.Container} {
    font-size: ${fluid(18, 24)};
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: auto / span 12;

    ${ReadMoreStyles.ReadMore} {
      display: block;
    }
  }
`;
const Content = styled(m.div) `
  ${contentStyles};

  &[data-read-more='closed'] {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;

    @media ${from(Device.TabletLarge)} {
      -webkit-line-clamp: 2;
    }
  }

  a {
    ${fonts.apparat.bold}
    color: ${brand.primary.orange};
  }

  p {
    ${paragraphMedium}
    font-size: ${fluid(18, 20)};
    line-height: ${fluid(28, 30)};
  }
`;
const RichTextStyles = {
    Container,
    Content,
    Title,
    ContentWrapper,
};
export default RichTextStyles;
